export default class ColorManager {
  constructor() {
    this._selectedColor = [0,0,0,1];
    this._setters = [];
  }
  set(color, setterIdx = -1) {
    this._selectedColor = color;
    this._setters.forEach((setter, i) => {
      if(i !== setterIdx) setter(this._selectedColor);
    });
  }
  get() {
    return this._selectedColor.slice();
  }
  register(setter) {
    return this._setters.push(setter) - 1;
  }
  normalize([r, g, b, a255]) {
    return [r, g, b, Math.round(a255 / 255 * 100) / 100];
  }
  convertTo8bit([r, g, b, a]) {
    return [r, g, b, Math.round(a * 255)];
  }
}
